import {DeclarationStatus} from 'types/declarations';

import {ActiveStatuses, GtinStatuses} from 'types/gtins';

import {
    AuthenticStatus,
    CheckStatus,
    DocumentStatus,
    GdsStatus,
    OrderStatus,
    ProductsStatus,
} from '../dictionaries';

export const STATUS_COLOR_LIST = {
    GRAY: '#848484',
    GRAY_ALT: '#607C90',
    GREEN: '#4ABD74',
    GREEN_ALT: '#55CC52',
    RED: '#F54849',
    ORANGE: '#FF9500',
    BLUE: '#6466E9',
    YELLOW: '#C5A400',
    TEAL: '#2AD0BF',
};

export const PRODUCT_STATUS_COLORS: {DEFAULT: string} & Partial<Record<ProductsStatus, string>> = {
    [ProductsStatus.GENERATED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [ProductsStatus.ISSUED]: STATUS_COLOR_LIST['YELLOW'],
    [ProductsStatus.APPLIED]: STATUS_COLOR_LIST['ORANGE'],
    [ProductsStatus.INTRODUCED]: STATUS_COLOR_LIST['BLUE'],
    [ProductsStatus.SOLD]: STATUS_COLOR_LIST['GRAY'],
    [ProductsStatus.DROPOUT]: STATUS_COLOR_LIST['GRAY_ALT'],
    [ProductsStatus.AGGREGATED]: STATUS_COLOR_LIST['GREEN'],
    [ProductsStatus.DISAGGREGATED]: STATUS_COLOR_LIST['GRAY'],
    [ProductsStatus.ANNULLED]: STATUS_COLOR_LIST['RED'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const RECEIPT_STATUS_COLORS = {
    [CheckStatus.NEW]: STATUS_COLOR_LIST['BLUE'],
    [CheckStatus.CLOSED]: STATUS_COLOR_LIST['RED'],
    [CheckStatus.DECLINED]: STATUS_COLOR_LIST['ORANGE'],
    [CheckStatus.APPROVED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [CheckStatus.CREATED]: STATUS_COLOR_LIST['GRAY_ALT'],
    [CheckStatus.PROCESSED]: STATUS_COLOR_LIST['GREEN'],

    [CheckStatus.UNDER_APPROVAL]: STATUS_COLOR_LIST['TEAL'],
    [CheckStatus.RETURNED]: STATUS_COLOR_LIST['BLUE'],
    [CheckStatus.PENDING]: STATUS_COLOR_LIST['GRAY'],
    [CheckStatus.APPROVED_FOR_SHIPMENT]: STATUS_COLOR_LIST['YELLOW'],
    [CheckStatus.CHECK_SUCCESS]: STATUS_COLOR_LIST['GREEN'],
    [CheckStatus.CHECK_FAIL]: STATUS_COLOR_LIST['RED'],
    [CheckStatus.ACCEPTED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [CheckStatus.REJECTED]: STATUS_COLOR_LIST['RED'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const DOCUMENT_STATUS_COLORS = {
    [DocumentStatus.DECLINED]: STATUS_COLOR_LIST['RED'],
    [DocumentStatus.CREATED]: STATUS_COLOR_LIST['GRAY_ALT'],
    [DocumentStatus.APPROVED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [DocumentStatus.PROCESSED]: STATUS_COLOR_LIST['GREEN'],
    [DocumentStatus.DRAFT]: STATUS_COLOR_LIST['GRAY_ALT'],
    [DocumentStatus.IN_PROGRESS]: STATUS_COLOR_LIST['GRAY_ALT'],

    [CheckStatus.NEW]: STATUS_COLOR_LIST['BLUE'],
    [CheckStatus.UNDER_APPROVAL]: STATUS_COLOR_LIST['TEAL'],
    [CheckStatus.RETURNED]: STATUS_COLOR_LIST['BLUE'],
    [CheckStatus.PENDING]: STATUS_COLOR_LIST['GRAY'],
    [CheckStatus.APPROVED_FOR_SHIPMENT]: STATUS_COLOR_LIST['YELLOW'],
    [CheckStatus.CHECK_SUCCESS]: STATUS_COLOR_LIST['GREEN'],
    [CheckStatus.CHECK_FAIL]: STATUS_COLOR_LIST['RED'],
    [CheckStatus.ACCEPTED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [CheckStatus.REJECTED]: STATUS_COLOR_LIST['ORANGE'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const ORDER_STATUS_COLORS = {
    [OrderStatus.DECLINED]: STATUS_COLOR_LIST['RED'],
    [OrderStatus.CLOSED]: STATUS_COLOR_LIST['GRAY'],
    [OrderStatus.APPROVED]: STATUS_COLOR_LIST['BLUE'],
    [OrderStatus.READY]: STATUS_COLOR_LIST['GREEN'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const DECLARATIONS_STATUS_COLORS: {DEFAULT: string} & Record<DeclarationStatus, string> = {
    DRAFT: STATUS_COLOR_LIST['GRAY'],
    REJECTED: STATUS_COLOR_LIST['RED'],
    REVIEW: STATUS_COLOR_LIST['YELLOW'],
    SUBMITTED: STATUS_COLOR_LIST['BLUE'],
    CONFIRMED: STATUS_COLOR_LIST['GREEN'],
    REJECTED_AUTOMATIC: STATUS_COLOR_LIST['ORANGE'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const PRODUCT_GTIN_STATUS_COLORS: Record<GtinStatuses | 'DEFAULT', string> = {
    [GtinStatuses.PUBLISHED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [GtinStatuses.PENDING]: STATUS_COLOR_LIST['ORANGE'],
    [GtinStatuses.DRAFT]: STATUS_COLOR_LIST['BLUE'],
    [GtinStatuses.BLOCKED]: STATUS_COLOR_LIST['GRAY_ALT'],
    [GtinStatuses.REJECTED]: STATUS_COLOR_LIST['RED'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const PRODUCT_ACTIVE_STATUS_COLORS = {
    [ActiveStatuses.ACTIVE]: STATUS_COLOR_LIST['GREEN_ALT'],
    [ActiveStatuses.INACTIVE]: STATUS_COLOR_LIST['RED'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const GDS_STATUS_COLORS = {
    [GdsStatus.DRAFT]: STATUS_COLOR_LIST['GRAY_ALT'],
    [GdsStatus.SUBMITTED]: STATUS_COLOR_LIST['BLUE'],
    [GdsStatus.REVIEW]: STATUS_COLOR_LIST['YELLOW'],
    [GdsStatus.CONFIRMED]: STATUS_COLOR_LIST['GREEN_ALT'],
    [GdsStatus.REJECTED]: STATUS_COLOR_LIST['RED'],
    [GdsStatus.REJECTED_AUTOMATIC]: STATUS_COLOR_LIST['ORANGE'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};

export const AUTHENTIC_STATUS_COLORS = {
    [AuthenticStatus.AUTHENTIC]: STATUS_COLOR_LIST['GREEN'],
    [AuthenticStatus.COUNTERFEIT]: STATUS_COLOR_LIST['RED'],
    DEFAULT: STATUS_COLOR_LIST['GRAY'],
};
